<template>
  <div class="notify" :class="[status, size]">
    <SvgIcon :icon="status" />
    <slot>
      <span>{{ text }}</span>
    </slot>
    <button v-if="closable" type="button">
      <SvgIcon icon="x" />
    </button>
  </div>
</template>

<script lang="ts" src="./NotifyComponent.ts"></script>

<style scoped lang="scss" src="./NotifyComponent.scss"></style>
